var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.992 28.847C3.762 26.692-.194 20.905.13 14.44c.177-3.13.945-5.344 2.716-7.824C5.445 2.956 10.08.564 14.538.535c2.923 0 7.292 1.653 9.654 3.69l1.24 1.063-2.923 2.362-2.952 2.361-.945-.708c-2.745-2.067-6.524-1.742-9.093.767-2.863 2.775-2.745 7.676.236 10.274 1.477 1.3 2.687 1.742 4.842 1.742 2.332 0 4.015-.797 5.491-2.568 1.86-2.244 3.573-2.716 5.403-1.477 1.919 1.3 2.244 3.13.915 5.256-1.594 2.509-4.753 4.753-8 5.756-2.067.62-6.318.532-8.414-.206z",
    fill: "#0E4E9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 17.687c-.295-.531-1.919-5.61-1.919-6.081 0-1.034 1.004-.207 1.89 1.535.501 1.004 1.033 1.86 1.15 1.86.237 0 6.407-4.724 12.4-9.507 2.717-2.184 3.455-2.51 3.455-1.594 0 .207-3.012 3.041-6.702 6.259-3.72 3.218-7.204 6.288-7.765 6.82-1.003.944-2.155 1.27-2.509.708z",
    fill: "#0E4E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.95daf123e8165fad1ab27f7f4dea2b91.svg";
export { ForwardRef as ReactComponent };